module.exports = __webpack_public_path__ + "static/media/sacramento-skyline-finish@3x.28837e5f.png";